export const ERR_ACCOUNT_REMOVED =
    'Your account has been deleted and you cannot sign in. Please contact support if you believe this is an error.';

export const ERR_TRY_RELOADING =
    'Please try reloading this page in a few moments';

export const ERR_AUTH_PROCESS =
    'Something went wrong in the authentication process';

export const ERR_AUTH_TIMED_OUT = 'Authentication timed out';

export const ERR_USER_CREATE =
    'Something went wrong when we were creating your user account. You can try again in a few moments';

export const MSG_ACCOUNT_ALREADY_EXISTS = 'You have set up your account already. Navigate to the Settings page if you wish to cancel it.';

export const ERR_UNKNOWN = 'An error occurred';

export const ERR_RESOURCE_DB = 'Something went wrong when loading from the resource database';

export const ERR_FILE_READ = 'Failed to read the chosen file. Please try choosing it again.';

export const ERR_FILE_EMPTY = 'The chosen file is empty. Please choose a GanttProject file.';

export const ERR_PROJECT_WRITE = 'Failed to upload a new project version. Please try again in a few moments.';

export const ERR_PROJECT_LOCKED =
    'The project has been locked. A new version can be uploaded once the project is unlocked.';

export const MSG_PROJECT_VERSION_UPLOADED = 'The new project version has been uploaded.';

/** Maps a failed project write (/p/write) to a user-facing message.
 *  The handler replies 423 when the project is locked by another member or the lock token doesn't match.
 *  The upload menu item is disabled under another member's lock and sends the user's own token,
 *  so this happens only when the lock changed after the page had loaded the project. */
export function projectWriteErrorMessage(status: number): string {
  // TODO: handle 402 (Payment Required): /p/write rejects a member's write when the team balance is negative.
  return status === 423 ? ERR_PROJECT_LOCKED : ERR_PROJECT_WRITE;
}

/** Maps UserGet (/user/get) HTTP status to a user-facing message.
 *  The handler returns 403 only when the account is soft-deleted (isRemoved), and 401 when the
 *  Firebase id token is invalid, expired, or does not match the claimed user id. */
export function userGetErrorMessage(status: number): string {
  switch (status) {
    case 403:
      return ERR_ACCOUNT_REMOVED;
    default:
      // A reload makes Firebase mint a fresh token, which is what an expired one needs.
      return ERR_TRY_RELOADING;
  }
}
